export const buildTime = "14/10, 10:29";
